<template>
  <div class="app-page">
    <bind-relation-table></bind-relation-table>
  </div>
</template>

<script>

import BindRelationTable from './BindRelationTable.vue';

export default {
  name: 'UserList',
  components: {
    BindRelationTable,
  },
};
</script>

<style lang="less" scoped>
</style>
